import { render } from "./PartPlayerAudio.vue?vue&type=template&id=137e837b"
import script from "./PartPlayerAudio.vue?vue&type=script&lang=js"
export * from "./PartPlayerAudio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__